module.exports = "/static/js/4c43ebf5d3e1bd87c0334993ba3e8e47.png";